define('model/geocode/geocode',['../selector'], function(selector) {
    'use strict';
    return function(json) {
        return selector(json, 'results', 'address, dist, position, score, type, addressRanges, boundingBox') || {};
    };
});

